module.exports = __webpack_public_path__ + "static/media/fundo_pontos.4fc8eb17.jpg";